import { useEffect } from 'react';

import { $$toast } from '@doger/ui/components/ui/toast';
import { useJWT } from '@doger/core/modules/auth';

import { useTranslation } from '../../../shared/i18n';

type UseApplyForAnWhitelistReminderOptions = {
  enabled?: boolean;
  onShowWhitelistModal?: () => void;
};

export const useApplyForAnWhitelistReminder = ({
  enabled,
  onShowWhitelistModal,
}: UseApplyForAnWhitelistReminderOptions = {}) => {
  const jwt = useJWT();
  const { t } = useTranslation('app');

  useEffect(() => {
    if (!enabled) {
      return;
    }

    if (!jwt) {
      return;
    }

    // Show usecase modal if user doesn't have a usecase set
    if (!jwt.completedProfile && jwt.isConfirmed) {
      const ref = {
        current: undefined as number | string | undefined,
      };
      const timeoutId = setTimeout(() => {
        ref.current = $$toast.info(t('whitelist.reminder.title'), {
          description: t('whitelist.reminder.description'),
          action: {
            label: t('whitelist.reminder.action'),
            onClick: () => {
              onShowWhitelistModal?.();
            },
          },
          duration: 60_000,
        });
      }, 1000); // Small delay to ensure other modals are closed first

      return () => {
        clearTimeout(timeoutId);

        if (ref.current !== undefined) {
          $$toast.dismiss(ref.current);
        }
      };
    }
  }, [enabled, jwt]);
};
